import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {StatusToggl} from "../StatusToggl";
import {REPORTS_DATA, getLocalizedReportTitle} from "../../reports";
import {SendReportLink} from "../reports/SendReportLink";
import { withTranslation } from 'react-i18next';


class UserEmailAlertsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailsAlert: false,
            impressionsAlert: false,
            criticOdsVsYesterdayAlert: false,
            criticCostVsTimeAlert: false,
            criticOdsVsTodayAlert: false,
            criticOdsVsLast7DaysAlert: false,
            criticROASVsLastPeriodAlert: false,
            criticACOSVsLastPeriodAlert: false,
            budgetExceededAlert: false,
            flexIndicatorAlert: false,
            goalAlert: false,
            activeReports: []
        };
        this.handleUrlAlertChange = this.handleUrlAlertChange.bind(this);
        this.handleImpressionsAlertChange = this.handleImpressionsAlertChange.bind(this);
        this.handleCriticOdsVsYesterdayAlertChange = this.handleCriticOdsVsYesterdayAlertChange.bind(this);
        this.handleCriticCostVsTimeAlertChange = this.handleCriticCostVsTimeAlertChange.bind(this);
        this.handleCriticOdsVsLast7DaysAlertChange = this.handleCriticOdsVsLast7DaysAlertChange.bind(this);
        this.handleCriticOdsVsTodayAlertChange = this.handleCriticOdsVsTodayAlertChange.bind(this);
        this.handleCriticROASVsLastPeriodAlertChange = this.handleCriticROASVsLastPeriodAlertChange.bind(this);
        this.handleCriticACOSVsLastPeriodAlertChange = this.handleCriticACOSVsLastPeriodAlertChange.bind(this);
        this.handleBudgetExceededAlertChange = this.handleBudgetExceededAlertChange.bind(this);
        this.handleFlexIndicatorAlertChange = this.handleFlexIndicatorAlertChange.bind(this);
        this.handleGoalAlertChange = this.handleGoalAlertChange.bind(this);
        this.handleReportChange = this.handleReportChange.bind(this);
    }
    componentDidMount() {
        this.getAlertStatus();
    }

    getAlertStatusAPIUrl() {
        return "user/"+this.props.userId+"/module/marketing/alerts";
    }

    getAlertStatus() {
        new APIClient(API_URL + this.getAlertStatusAPIUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response['error_message']);
            }
            else {
                this.setState({
                    impressionsAlert:response.data.impressions_alert_is_active,
                    emailsAlert:response.data.url_alert_is_active,
                    criticOdsVsYesterdayAlert:response.data.critic_ods_vs_yesterday_alert_is_active,
                    criticCostVsTimeAlert:response.data.critic_cost_vs_time_alert_is_active,
                    criticOdsVsTodayAlert:response.data.critic_ods_vs_today_alert_is_active,
                    criticOdsVsLast7DaysAlert:response.data.critic_ods_vs_last_7_days_alert_is_active,
                    criticROASVsLastPeriodAlert:response.data.critic_roas_vs_last_period_alert_is_active,
                    criticACOSVsLastPeriodAlert:response.data.critic_acos_vs_last_period_alert_is_active,
                    budgetExceededAlert:response.data.budget_exceeded_alert_is_active,
                    flexIndicatorAlert:response.data.flex_indicator_alert_is_active,
                    goalAlert:response.data.goal_alert_is_active,
                    activeReports: response.data.active_reports
                });
            }
        })

    }

    getEditUserAlertsAPIUrlBase() {
        return API_URL + 'user/' + this.props.userId + '/module/marketing/alerts/'
    }

    getEditUserReportsAPIUrlBase() {
        return API_URL + 'user/' + this.props.userId + '/module/marketing/reports/'
    }

    handleUrlAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `url-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleImpressionsAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `impression-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleCriticOdsVsYesterdayAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `ods-vs-yesterday-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleCriticCostVsTimeAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `cost-vs-time-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleCriticOdsVsLast7DaysAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `ods-vs-last-7-days-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleCriticOdsVsTodayAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `ods-vs-today-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleCriticROASVsLastPeriodAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `roas-vs-last-period-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleCriticACOSVsLastPeriodAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `acos-vs-last-period-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleBudgetExceededAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `budget-exceeded-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleFlexIndicatorAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `flex-indicator-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleGoalAlertChange(shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserAlertsAPIUrlBase() + `goal-email-alert/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }
        })
    }

    handleReportChange(reportType, shouldActivate) {
        const action = shouldActivate ? 'activate' : 'deactivate';
        new APIClient(this.getEditUserReportsAPIUrlBase() + `${reportType}/${action}`).call('POST').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
                // Asi vuelve al estado original
                this.setState({
                    ...this.state
                });
            }
        })
    }

    renderTableData() {
        const { t } = this.props;
        return (
            <div className="table-box">
                <table className="table table-striped">
                    <tbody>
                        <tr>
                        <td className="">{t('user_email_alerts.url_down')}</td>
                        <td className="status-cell">
                            <StatusToggl onChange={this.handleUrlAlertChange}
                                         active={this.state.emailsAlert}/>
                        </td>
                        </tr>
                        <tr>
                        <td className="">{t('user_email_alerts.no_impressions')}</td>
                        <td className="status-cell">
                            <StatusToggl onChange={this.handleImpressionsAlertChange}
                                         active={this.state.impressionsAlert}/>
                        </td>
                        </tr>
                        <tr>
                            <td className="">{t('user_email_alerts.critical_cost_vs_time')}</td>
                            <td className="status-cell">
                                <StatusToggl onChange={this.handleCriticCostVsTimeAlertChange}
                                             active={this.state.criticCostVsTimeAlert}/>
                            </td>
                        </tr>
                        <tr>
                            <td className="">{t('user_email_alerts.critical_yesterday_vs_ideal')}</td>
                            <td className="status-cell">
                                <StatusToggl onChange={this.handleCriticOdsVsYesterdayAlertChange}
                                             active={this.state.criticOdsVsYesterdayAlert}/>
                            </td>
                        </tr>
                        <tr>
                            <td className="">{t('user_email_alerts.critical_last_7_days_vs_ideal')}</td>
                            <td className="status-cell">
                                <StatusToggl onChange={this.handleCriticOdsVsLast7DaysAlertChange}
                                             active={this.state.criticOdsVsLast7DaysAlert}/>
                            </td>
                        </tr>
                        <tr>
                            <td className="">{t('user_email_alerts.critical_today_vs_ideal')}</td>
                            <td className="status-cell">
                                <StatusToggl onChange={this.handleCriticOdsVsTodayAlertChange}
                                             active={this.state.criticOdsVsTodayAlert}/>
                            </td>
                        </tr>
                        <tr>
                            <td className="">{t('user_email_alerts.critical_roas_vs_last_period')}</td>
                            <td className="status-cell">
                                <StatusToggl onChange={this.handleCriticROASVsLastPeriodAlertChange}
                                             active={this.state.criticROASVsLastPeriodAlert}/>
                            </td>
                        </tr>
                        <tr>
                            <td className="">{t('user_email_alerts.critical_acos_vs_last_period')}</td>
                            <td className="status-cell">
                                <StatusToggl onChange={this.handleCriticACOSVsLastPeriodAlertChange}
                                             active={this.state.criticACOSVsLastPeriodAlert}/>
                            </td>
                        </tr>
                        <tr>
                            <td className="">{t('user_email_alerts.budget_exceeded')}</td>
                            <td className="status-cell">
                                <StatusToggl onChange={this.handleBudgetExceededAlertChange}
                                             active={this.state.budgetExceededAlert}/>
                            </td>
                        </tr>
                        <tr>
                            <td className="">{t('user_email_alerts.flex_indicator_critical')}</td>
                            <td className="status-cell">
                                <StatusToggl onChange={this.handleFlexIndicatorAlertChange}
                                             active={this.state.flexIndicatorAlert}/>
                            </td>
                        </tr>
                        <tr>
                            <td className="">{t('user_email_alerts.goal_critical')}</td>
                            <td className="status-cell">
                                <StatusToggl onChange={this.handleGoalAlertChange}
                                             active={this.state.goalAlert}/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    getReportIsActive(reportType) {
        return this.state.activeReports.includes(reportType);
    }

    renderReportsTableData() {
            return (
                <div className="table-box">
                    <table className="table table-striped">
                        <tbody>
                        {Object.keys(REPORTS_DATA).map((reportType) => (
                            <tr>
                                <td className="">{getLocalizedReportTitle(reportType, this.props.i18n.language)}<SendReportLink userId={this.props.userId} reportType={reportType} /></td>
                                <td className="status-cell">
                                    <StatusToggl onChange={(shouldActivate) => {this.handleReportChange(reportType, shouldActivate)}}
                                                 active={this.getReportIsActive(reportType)}/>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )
        }


    render() {
        const { t } = this.props;
        return [
            <div className="section-body-item -wide">
                <div className="box col-12 mb-4">
                    <header className="box-header">
                        <h2 className="box-title">{t('user_email_alerts.want_receive_alerts')} </h2>
                    </header>
                    {this.renderTableData()}
                </div>
                <div className="box col-12 mb-4">
                    <header className="box-header">
                        <h2 className="box-title">{t('user_email_alerts.reports')}</h2>
                    </header>
                    {this.renderReportsTableData()}
                </div>
            </div>

        ]
    }
}

export const UserEmailAlerts = withTranslation()(UserEmailAlertsComponent);

